import PubNub, {
  PublishParameters,
  PublishResponse,
  SubscribeParameters,
  PubnubConfig
} from "pubnub";

export class MQ {
  private _pubnub: PubNub;

  constructor(config: PubnubConfig) {
    this._pubnub = new PubNub({
      publishKey: config.publishKey,
      subscribeKey: config.subscribeKey,
      ssl: true
    });
  }

  get pubnub(): PubNub {
    return this._pubnub;
  }

  async publish(config: PublishParameters): Promise<PublishResponse> {
    return new Promise<PublishResponse>(async (resolve, reject) => {
      try {
        const publishResponse: PublishResponse = await this.pubnub.publish(config);
        resolve(publishResponse);
      } catch (e) {
        reject(e);
      }
    });
  }

  async subscribe(config: SubscribeParameters): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        this.pubnub.subscribe({
          channels: config.channels,
          withPresence: false
        });
      } catch (e) {
        reject(e);
      }
    });
  }

  async unsubscribe(config: SubscribeParameters): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        this.pubnub.unsubscribe({ channels: config.channels });
        resolve(config.channels);
      } catch (e) {
        reject(e);
      }
    });
  }
}

// const MessageQueueManager = new MQ({
//   publishKey: process.env.REACT_APP_PN_PUB_KEY,
//   subscribeKey: process.env.REACT_APP_PN_SUB_KEY || ''
// });

// export { MessageQueueManager };

